import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import {
  baseUniDriverFactory,
  findByHook,
} from '../test-utils/utils/unidriver';
import { dataHooks } from './constants';
import { SocialPostPreviewSkin } from './SocialPostPreview.types';

export const socialPostPreviewDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),

    // Returns skin value
    getSkin: () => base.attr('data-skin') as Promise<SocialPostPreviewSkin>,

    // Returns caption value
    getCaption: (): Promise<string> =>
      findByHook(base, dataHooks.socialPostPreviewCaption).text(),

    // Returns profile name value
    getProfileName: (): Promise<string> =>
      findByHook(base, dataHooks.socialPostPreviewProfileName).text(),

    // Returns profile image source value
    getProfileImageSrc: (): Promise<string | null> => base.attr('data-profile'),
  };
};

export type SocialPostPreviewUniDriver = ReturnType<
  typeof socialPostPreviewDriverFactory
>;
